import React, { useEffect, useState } from "react";
import { debounce } from "lodash-es";
import { Marker } from "react-map-gl";

import { MarkerIcon, BaseMap, BaseMapProps, MapPopup, IMapPopup } from "shared/components";
import { ICoordinate } from "shared/types";
import { GlobalMapStyle, StyledDragPopup } from "./styles";

interface DragEvent {
  lngLat: [number, number];
}

export interface MapProps extends BaseMapProps {
  popup?: IMapPopup;
  draggable?: {
    tooltip: string;
    setCoordinates: (coordinates: ICoordinate) => void;
  };
}

export const Map: React.FC<MapProps> = ({ popup, coordinates, draggable, ...rest }) => {
  const [draggingCoordinates, setDraggingCoordinates] = useState<ICoordinate | null>(
    coordinates || null
  );

  useEffect(() => {
    if (coordinates) {
      setDraggingCoordinates(coordinates);
    }
  }, [coordinates]);

  const onDrag = (event: DragEvent) => {
    setDraggingCoordinates({
      longitude: event.lngLat[0],
      latitude: event.lngLat[1],
    });
  };

  const onDragEnd = (event: DragEvent) => {
    if (draggable) {
      draggable.setCoordinates({
        longitude: event.lngLat[0],
        latitude: event.lngLat[1],
      });
    }
  };

  return (
    <React.Fragment>
      <GlobalMapStyle />
      <BaseMap coordinates={coordinates} {...rest}>
        {coordinates && (
          <>
            {popup && <MapPopup coordinates={coordinates} {...popup}></MapPopup>}
            <Marker
              {...coordinates}
              draggable={!!draggable}
              onDragEnd={onDragEnd}
              onDrag={debounce(onDrag, 5)}
              offsetTop={-32}
              offsetLeft={-15}
            >
              <MarkerIcon isDraggable={!!draggable} />
            </Marker>
            {draggable && coordinates && (
              <StyledDragPopup
                {...(draggingCoordinates || coordinates)}
                closeButton={false}
                tipSize={5}
                offsetTop={-40}
                anchor="bottom"
              >
                {draggable.tooltip}
              </StyledDragPopup>
            )}
          </>
        )}
      </BaseMap>
    </React.Fragment>
  );
};
